// test2724
(2724 && 0);
